"use client";
import { fontSizes } from "@/constants/constants";
import React from "react";

const LiveChatButton = ({ classStyle, buttonText = "GET A QUOTE", icon }) => {
  const handleClick = () => {
    if (typeof window === "undefined") return;
    const tawk = window.Tawk_API;
    if (tawk && typeof tawk.maximize === "function") {
      tawk.maximize();
    } else {
      // Widget still loading — TawkChat's onLoad handler opens it once ready.
      window.__tawkOpenOnLoad = true;
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`group inline-flex items-center justify-center gap-2 px-8 fl:px-4 md:px-8 py-3 font-semibold tracking-wide shadow-lg rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl ${fontSizes.base} ${classStyle}`}
    >
      {buttonText}
      {icon || (
        <svg
          className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </button>
  );
};

export default LiveChatButton;
